import {
  ReadOnlyField,
  ReadOnlyFieldProps,
  ReadOnlyValue,
  ReadOnlyValueG4PProps,
  useComponentsWrapperContext,
} from "@dbn/omnichannel-design-system-g4p";

export function ReadOnlyFieldToValue(
  props: ReadOnlyFieldProps | ReadOnlyValueG4PProps
) {
  const { componentType } = useComponentsWrapperContext();
  return (
    <>
      {componentType === "notG4p" && (
        <ReadOnlyField {...(props as ReadOnlyFieldProps)} />
      )}
      {(!componentType || componentType === "g4p") && (
        <ReadOnlyValue {...(props as ReadOnlyValueG4PProps)} />
      )}
    </>
  );
}
